/* global google */

import { loadScript } from "../utils/utils";

const apiKey = "AIzaSyASKZZvZuhlOPEvvv9vzckyEfnmrhPZ6Xw";
const scriptURL = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
const gmarkers = [];

export function init() {
	const elements = Array.from(document.querySelectorAll(".js-google-map"));

	if (!elements.length) {
		return;
	}
	loadGoogleMaps(() => {
		elements.forEach((element) => {
			const locationsData = JSON.parse(element.dataset.locations);
			const map = createMap(element, locationsData);
			addMarkers(locationsData, map);
		});
	});
}
// http://jsfiddle.net/x5R63/

function addMarkers(locationsData, map) {
	/* this seems like a big repetition but you can't
	   just update the URL of the marker, it has to be
		 an instance in its own right */
	const icon = {
		url: "/assets/icons/mapmarker.svg",
		size: new google.maps.Size(28, 39),
		scaledSize: new google.maps.Size(28, 39),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(28, 39),
	};
	const activeIcon = {
		url: "/assets/icons/mapmarker-active.svg",
		size: new google.maps.Size(28, 39),
		scaledSize: new google.maps.Size(28, 39),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(28, 39),
	};
	const infoBox = document.getElementById("js-map-infowindow");
	const infoText = infoBox.getElementsByClassName("js-location-details")[0];
	const bounds = new google.maps.LatLngBounds();
	// const closeButtonString = '<div class="c-close"></div>';
	const contentString = [];
	for (var i = 0; i < locationsData.length; i++) {
		contentString[i] =
			"<strong>" +
			locationsData[i].placeName +
			"</strong><br/>" +
			locationsData[i].placeAddress +
			locationsData[i].contactDetails;
		const marker = new google.maps.Marker({
			icon: icon,
			position: locationsData[i].LatLng[0],
			map: map,
			optimized: false,
			zIndex: 1,
		});

		bounds.extend(marker.position);
		gmarkers.push(marker);
		google.maps.event.addListener(
			marker,
			"click",
			(function (marker, i) {
				return function () {
					// reset all markers
					for (let m = 0; m < gmarkers.length; m++) gmarkers[m].setIcon(icon);
					// highlight current marker
					marker.setIcon(activeIcon);
					// show the infobox
					if (infoBox.hasAttribute("hidden")) {
						infoBox.removeAttribute("hidden");
					}
					// populate the infobox
					infoText.innerHTML = contentString[i];
				};
			})(marker, i),
		);
	}
	map.fitBounds(bounds);
	var listener = google.maps.event.addListener(map, "idle", function () {
		if (map.getZoom() > 15) map.setZoom(15);
		google.maps.event.removeListener(listener);
	});

	// handle the close button on the infowindow
	const closeInfoBox = document.getElementsByClassName("js-mapwindow-close")[0];
	closeInfoBox.addEventListener(
		"click",
		function () {
			for (let m = 0; m < gmarkers.length; m++) gmarkers[m].setIcon(icon);
			infoBox.setAttribute("hidden", true);
		},
		false,
	);
	google.maps.event.addListener(map, "click", function () {
		for (let m = 0; m < gmarkers.length; m++) gmarkers[m].setIcon(icon);
		infoBox.setAttribute("hidden", true);
	});
}

function loadGoogleMaps(callback) {
	const loaded = typeof google === "object" && typeof google.maps === "object";
	loaded ? callback() : loadScript(scriptURL, callback);
}

function createMap(canvas, options) {
	const defaults = {
		disableDefaultUI: true,
		mapTypeControl: false,
		zoom: 9,
		zoomControl: true,
	};

	return new google.maps.Map(canvas, {
		...defaults,
		...options,
	});
}
